export function formatSaveOrderRequest(
  requiredInfo,
  additionalInfo,
  choosenPaymentMethod,
  paymentToken,
  currentUserShippingInfo,
  mainPaymentMethod,
  countryId
) {
  /* formatting the checkout data */

  let requestData = {
    "billing[prefix]": requiredInfo.prefix,
    "billing[lastname]": requiredInfo.lastname,
    "billing[firstname]": requiredInfo.firstname,
    "billing[email]": requiredInfo.email,
    "billing[company]": requiredInfo.company ?? "",
    "billing[street][]": [requiredInfo.adresse, additionalInfo.adresseComplement],
    "billing[country_id]": countryId,
    "billing[city]": requiredInfo.city,
    "billing[postcode]": requiredInfo.postalcode,
    "billing[telephone]": requiredInfo.phone,
    "billing[upper_floor]": requiredInfo.floor === "yes" ? "1" : "0",
    "billing[elevator]": requiredInfo.elevator === "yes" ? "1" : "0",
    "billing[mcp_customer_comment]": additionalInfo.comment_info,
    "billing[use_for_shipping]": requiredInfo.shippingAsBilling === true ? "1" : "0",
    mcp_customer_installation: additionalInfo.comment_explain,
    "payment[method]": mainPaymentMethod,
    "payment[hftoken]": paymentToken || "", //empty in case of paypal
    "payment[be2bill_method]": choosenPaymentMethod ? choosenPaymentMethod.code : "",
    "proxiserve_optin": requiredInfo.proxiserve_optin,
  };
  if (requiredInfo.shippingAsBilling === false) {
    requestData["shipping[prefix]"] = requiredInfo.prefix;
    requestData["shipping[lastname]"] = requiredInfo.billingLastname;
    requestData["shipping[firstname]"] = requiredInfo.billingFirstname;
    (requestData["shipping[email]"] = requiredInfo.email),
      (requestData["shipping[company]"] = requiredInfo.billingCompany ?? "");
    requestData["shipping[street][]"] = [
      requiredInfo.billingAdresse,
      additionalInfo.billingAdresseComplement,
    ];
    requestData["shipping[country_id]"] = countryId;
    requestData["shipping[city]"] = requiredInfo.billingCity;
    requestData["shipping[postcode]"] = requiredInfo.billingPostalcode;
    requestData["shipping[telephone]"] = requiredInfo.billingPhone;
  }

  if (currentUserShippingInfo)
    requestData["billing[address_id]"] = currentUserShippingInfo.entityId
      ? `${currentUserShippingInfo.entityId}`
      : 0;
  if (choosenPaymentMethod && choosenPaymentMethod.title)
    requestData[`payment[${choosenPaymentMethod.code}][label]`] = choosenPaymentMethod.title;

  /* preparing the form-data request */

  let bodyFormData = new FormData();
  Object.keys(requestData).forEach(key => {
    if (typeof requestData[key] === "string") bodyFormData.append(key, requestData[key]);
    else if (typeof requestData[key] === "object" && requestData[key].length)
      requestData[key].forEach(value => bodyFormData.append(key, value));
    else if (typeof requestData[key] === "boolean"){
        bodyFormData.append(key, +requestData[key]); // transform into 0|1
    }
  });

  return bodyFormData;
}
